import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para cualquier nivel de experiencia?',
    a: 'Sí. Funciona tanto si sos recién recibida como si tenés años de experiencia. El Código Alimentario te da el sistema estructurado que la formación universitaria no te dio, adaptado a cada nivel de complejidad clínica.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibís un email con el link de acceso a todos los productos. Acceso 100% digital desde cualquier dispositivo, las 24 horas.'
  }, {
    q: '¿Necesito ser Terapeuta Ocupacional?',
    a: 'Está diseñado principalmente para TO, pero es igualmente útil para Fonoaudiólogos, Nutricionistas Pediátricos y cualquier profesional que trabaje alimentación infantil.'
  }, {
    q: '¿El contenido está basado en evidencia?',
    a: 'Sí. Todo el material está basado en integración sensorial, enfoque responsivo y criterios clínicos actualizados. No es una guía de actividades genéricas, es un sistema de intervención estructurado.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas ni burocracia. Si no te sirve, te devolvemos el 100%.'
  }, {
    q: '¿Qué diferencia tiene con lo gratis en internet?',
    a: 'Lo gratuito son ideas sueltas sin criterio clínico. Esto es un sistema ordenado con protocolos, fichas técnicas, criterios de avance y herramientas de registro que te permiten intervenir con precisión y medir resultados reales.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-surface py-16 px-4" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-ink font-serif" data-id="element-81">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-border rounded-xl overflow-hidden shadow-sm" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-cream/50 transition-colors" data-id="element-84">
                <span className="font-bold text-ink text-base md:text-lg pr-4 font-serif" data-id="element-85">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-primary transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>
              <AnimatePresence data-id="element-87">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 text-muted border-t border-border pt-4 text-sm md:text-base font-medium leading-relaxed" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}